/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { grey, purple } from '@material-ui/core/colors';
import { rgba } from 'polished';

export const AppWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;

  /* App Variables */
  --background-color: #ffffff;
  --background-color-rgb: 255, 255, 255;
  --background-secondary-color: ${grey[100]};
  --border-color: ${grey[200]};
  --border-dark-color: ${grey[300]};
  --button-text-color: ${grey[300]};
  --button-border-color: ${grey[800]};
  --button-border-dark-color: ${grey[600]};
  --text-color: ${grey[800]};
  --text-secondary-color: ${grey[700]};
  --card-bg-color: ${grey[50]};
  --event-item-bg-color: ${grey[300]};
  --brand-color: ${purple[600]};
  --text-light-color: ${grey[200]};

  /* Calendar */
  --calendar-available-bg-color: ${rgba(purple[600], 0.2)};
  --calendar-available-text-color: var(--text-color);
  --calendar-selected-bg-color: var(--brand-color);
  --calendar-selected-text-color: ${grey[50]};
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  a {
    color: black;
    text-decoration: none;
    width: fit-content;
    margin: 0 0 1rem 0;

    &:hover {
      text-decoration: none;
    }
  }
`;
